<template style="height: 100%;">
  <div class="File_view">

  </div>
</template>
<script>
export default {
  data() {
    return {

    }
  },
  components: {

  },
  methods: {

  },
  watch: {

  },
  mounted() {

  }
}
</script>

<style>

  
</style>
